import { CampaignVisibilityConfig } from 'mini-campaign/lib/store/schema/CampaignVisibilityConfig';
import { CampaignId } from 'mini-campaign-bootstrap/lib/schema/CampaignId';
import { isLightningIdPresent } from 'mini-campaign-bootstrap/lib/utils/isLightningIdPresent';

const focusedOtherCampaignVisibility: CampaignVisibilityConfig = {
    remoteCampaignId: CampaignId.MiniMailFocusOthers,
};

export const getFocusedOtherCampaignVisibility = (): CampaignVisibilityConfig =>
    focusedOtherCampaignVisibility;

export const isFocusedOtherCampaignVisible = () =>
    isLightningIdPresent(focusedOtherCampaignVisibility.remoteCampaignId);
